import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../components/global/Button';
import withModal from '../../../../components/global/modal/withModal';

const propTypes = {
  onRequestClose: PropTypes.func,
};

const WebGalleryFavoriteDownloadTipModal = ({ onRequestClose }) => {
  return (
    <div className="p-1 text-center">
      <h3 className="mb-3">Quick Tip!</h3>
      <p className="mb-3">
        Please download your photos as you favorite them! Favorited photos are
        only downloadable individually, and not in bulk.
      </p>
      <Button btnBlock onClick={onRequestClose}>
        Got it
      </Button>
    </div>
  );
};

WebGalleryFavoriteDownloadTipModal.propTypes = propTypes;

export const WEB_GALLERY_FAVORITE_DOWNLOAD_TIP_MODAL =
  'modal/WEB_GALLERY_FAVORITE_DOWNLOAD_TIP_MODAL';

export default withModal(WebGalleryFavoriteDownloadTipModal, {
  name: WEB_GALLERY_FAVORITE_DOWNLOAD_TIP_MODAL,
  hideHeader: true,
  size: 'xs',
});
